const ShopBag = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 32 32' fill='currentColor' {...props}>
    <path
      d='M11 23.1786C11.1778 25.0838 12.8201 26.435 15.3201 26.61V28H16.5753V26.61C19.3054 26.4058 21 24.9672 21 22.8384C21 21.0207 19.8598 19.9708 17.4435 19.3779L16.5753 19.164V14.819C17.9247 14.9453 18.8347 15.6355 19.0649 16.6659H20.8326C20.6339 14.8384 18.9812 13.5261 16.5753 13.3803V12H15.3201V13.4095C12.9874 13.6719 11.387 15.0911 11.387 17.0158C11.387 18.678 12.5481 19.8542 14.5879 20.3499L15.3201 20.5346V25.1422C13.9393 24.9478 12.9874 24.2284 12.7573 23.1786H11ZM15.0795 18.7947C13.8243 18.4933 13.1548 17.8518 13.1548 16.9478C13.1548 15.8688 14.0021 15.0717 15.3201 14.8578V18.853L15.0795 18.7947ZM16.9937 20.9332C18.5418 21.3026 19.2218 21.9149 19.2218 22.955C19.2218 24.209 18.228 25.045 16.5753 25.1713V20.836L16.9937 20.9332Z'
      fill='currentColor'
    />
    <path
      d='M16 2C18.7614 2 21 4.23858 21 7V8H11V7C11 4.23858 13.2386 2 16 2ZM23 8V7C23 3.13401 19.866 0 16 0C12.134 0 9 3.13401 9 7V8H2V28C2 30.2091 3.79086 32 6 32H26C28.2091 32 30 30.2091 30 28V8H23ZM4 10H28V28C28 29.1046 27.1046 30 26 30H6C4.89543 30 4 29.1046 4 28V10Z'
      fill='currentColor'
    />
  </svg>
);

export default ShopBag;
